import { emit, events } from '@estee/elc-service-bus';

type BaseConfig = {
    baseUrl: string;
    businessUnitId: string;
    clientId: string;
    environment: string;
};

export const startTranslations = async (stardustServiceConfig: BaseConfig) => {
    const config: BaseConfig = stardustServiceConfig || {};

    // @ts-ignore
    const translations = await (() => import('elc_service_translations/diContainer'))();

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    await translations.serviceStarter(config);

    emit(events.ECOMM_STARTED);
};